import { Axios } from '@src/context/Api/includes/Axios/Axios';
import { logger } from '@src/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isUndefined } from 'lodash';

/**
 * GetUserRoles
 *
 * Retrieves a list of user roles from the remote API via an authenticated request.
 *
 * @returns {Promise<{}>}
 * @constructor
 */
export const GetUserRoles = async (payload = {}) => {
  try {
    const requestArgs = {
      baseURL: config('API_URL'),
      method: 'GET',
      url: '/user/roles/get',
    };

    if (!isUndefined(payload)) {
      requestArgs.params = { ...{ queryKey: payload[0] }, ...payload[1] };
    }

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/requests/queries/auth/GetUserRoles.js -> GetUserRoles()', false, error);

    throw error;
  }
};
